import React, { FC } from 'react';

import { CheckDiscountModal } from '../check-discount/CheckDiscountModal';
import { CheckFeesModal } from '../check-fees/CheckFeesModal';
import { CheckMergeModal } from '../check-merge/CheckMergeModal';

import { CheckVoidModal } from './CheckVoidModal';
import { ClearCheckModal } from './ClearCheckModal';
import { TaxExemptModal } from './TaxExemptModal';
import type { UsedCheckPanelFooter } from './useCheckPanelFooter';

const CheckPanelFooterModals: FC<{ store: UsedCheckPanelFooter }> = ({ store }) => (
  <>
    <CheckDiscountModal
      open={store.modal.discount.isOpen}
      onDone={store.modal.discount.close}
    />
    <CheckVoidModal
      open={store.modal.voidCheck.isOpen}
      check={store.described.check}
      onClose={store.modal.voidCheck.close}
      onVoid={store.onVoidCheck}
      form={store.voidCheckForm}
      reasonOptions={store.voidReasonOptions ?? []}
    />
    <ClearCheckModal
      open={store.modal.clearCheck.isOpen}
      onClose={store.modal.clearCheck.close}
      onClearCheck={store.onClearCheck}
    />
    <CheckMergeModal
      key={store.modal.mergeCheck.resetKey}
      open={store.modal.mergeCheck.isOpen}
      close={store.modal.mergeCheck.close}
    />
    <CheckFeesModal
      open={store.modal.fees.isOpen}
      onClose={store.modal.fees.close}
    />
    <TaxExemptModal
      checkId={store.described.check?.id}
      open={store.modal.taxExempt.isOpen}
      onClose={store.modal.taxExempt.close}
    />
  </>
);

export { CheckPanelFooterModals };
